module.exports = __webpack_public_path__ + "media/images/flags/64/Northern-Mariana-Islands-661904fcc5ff78d4e386d33fa80e2342.png";